import * as Sentry from "@sentry/react";

/**
 * Royal Lady — Sentry frontend init.
 * Stub-safe: no REACT_APP_SENTRY_DSN → no init, no calls, no network noise.
 */

const dsn = (process.env.REACT_APP_SENTRY_DSN || "").trim();
const environment =
  process.env.REACT_APP_SENTRY_ENVIRONMENT ||
  (process.env.NODE_ENV === "production" ? "production" : "preview");

const SENSITIVE_KEYS = new Set([
  "password", "token", "access_token", "refresh_token", "authorization",
  "jwt", "otp", "otp_code", "code", "phone", "telephone", "mobile",
  "address", "line1", "line2", "pincode", "pin_code",
  "payment_id", "razorpay_payment_id", "razorpay_order_id",
  "card_number", "cvv", "secret", "api_key", "email",
]);

function scrub(value) {
  if (Array.isArray(value)) return value.map(scrub);
  if (value && typeof value === "object") {
    return Object.fromEntries(
      Object.entries(value).map(([k, v]) => [
        k,
        SENSITIVE_KEYS.has(String(k).toLowerCase()) ? "[Filtered]" : scrub(v),
      ])
    );
  }
  return value;
}

export const SENTRY_ENABLED = Boolean(dsn);

if (SENTRY_ENABLED) {
  try {
    Sentry.init({
      dsn,
      environment,
      release: process.env.REACT_APP_SENTRY_RELEASE,
      beforeSend(event) { return scrub(event); },
      beforeBreadcrumb(bc) { return scrub(bc); },
      tracesSampleRate: Number(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || 0),
      tracePropagationTargets: [/^\/api\//],
    });
  } catch (_e) {
    // Never let Sentry break page render.
  }
}

/** Report a caught error safely — no-op if Sentry is stubbed. */
export function reportError(err, ctx = {}) {
  try {
    if (SENTRY_ENABLED) {
      Sentry.withScope((scope) => {
        if (ctx.module) scope.setTag("module", ctx.module);
        scope.setContext("safe_extra", scrub(ctx));
        Sentry.captureException(err);
      });
    }
  } catch (_e) { /* swallow */ }
  // Always log to the console so devs see it in preview too.
  // eslint-disable-next-line no-console
  console.error("[royallady]", ctx.module || "app", err);
}
